import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDotGrid3x3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconDotGrid3x3"><Path d="M7 3H3V7H7V3Z" fill="currentColor"/><Path d="M14 3H10V7H14V3Z" fill="currentColor"/><Path d="M21 3H17V7H21V3Z" fill="currentColor"/><Path d="M7 10H3V14H7V10Z" fill="currentColor"/><Path d="M14 10H10V14H14V10Z" fill="currentColor"/><Path d="M21 10H17V14H21V10Z" fill="currentColor"/><Path d="M7 17H3V21H7V17Z" fill="currentColor"/><Path d="M14 17H10V21H14V17Z" fill="currentColor"/><Path d="M21 17H17V21H21V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDotGrid3x3;
